const marathi = [
  {
    // header section
    home: "मुख्यपृष्ठ",
    about: "आमच्याबद्दल",
    inner_about: "अक्का फाऊंडेशन बद्दल",
    inner_awards: "पुरस्कार आणि यश",
    founders: "संस्थापक",
    ourworks: "आमचे कार्य",
    empowerment: "सक्षमीकरण",
    education: "शिक्षण",
    environment: "पर्यावरण",
    health: "आरोग्य",
    artculture: "कला आणि संस्कृती",
    projectanandi: "प्रोजेक्ट आनंदी",
    drustiabhiyan: "दृष्टी अभियान",
    waterconservation: "जल साक्षरता रॅली",
    janjagarmanch: "जन जागर संवाद",
    gallery: "गॅलरी",
    photos: "फोटो",
    videos: "व्हिडीओ",
    press: "प्रेस & मेडिया",
    blogs: "ब्लॉग",
    contactus: "संपर्क करा",
    searchblog: "ब्लॉग शोधा",
    loadmore: "लादणे",
    // home-page---------------------------------------
    HP_hs_s6_h:
      "जेव्हा सेवाभाव आणि प्रयत्नांतून आकाराला येतो... एक 'सकारात्मक बदल'",
    HP_hs_s6_desc:
      "'महाराष्ट्र रत्न' पुरस्कार ही आमच्यासाठी अधिक जोमाने लोकसेवा करण्याची एक नवी प्रेरणा आहे.",

    HP_hs_s1_h: "अक्का फाऊंडेशन : समाजासाठी, समाजातील प्रत्येकासाठी",
    HP_hs_s1_desc:
      "शिक्षण, आरोग्य सेवा आणि आर्थिक मदतीच्या माध्यमातून समाजातील वंचित घटकांच्या सक्षमीकरणासाठी काम करणारी एक सेवाभावी संस्था.  ",

    HP_hs_s2_h: "अक्का फाऊंडेशन: आईपणाचा वारसा जपणारा आईच्या मायेचा हात ",
    HP_hs_s2_desc:
      "लातूरच्या माजी खासदार आदरणीय श्रीमती रूपाताई पाटील निलंगेकर यांच्या प्रेरणेतून अक्का फाऊंडेशनची सुरुवात करण्यात आली. जनसेवा ही आईपणाच्या आणि आपलेपणाच्या भावनेतून करा, असा संस्कार त्यांनी दिला. आपण ही पुढाकार घ्या...",

    HP_hs_s3_h: " कटिबद्धता...भावी पिढीच्या उज्ज्वल भविष्याशी",
    HP_hs_s3_desc:
      "संस्थेचे ध्येय आहे, समाजातील गरजू नागरिकांना सुखी, निरोगी आणि स्वावलंबी जीवनासाठी संधी आणि कौशल्ये प्रदान करून त्यांना समाजाच्या मुख्य प्रवाहात सामावून घेणे.  कृतीमधून प्रेरणा ",

    HP_hs_s4_h:
      "प्रोजेक्ट आनंदी: एक संवाद तिच्या निरोगी आणि तेजस्वी जीवनासाठी  ",
    HP_hs_s4_desc:
      "ग्रामीण भागात मासिक पाळी व महिला आरोग्यासाठी नाविन्यपूर्ण दृष्टिकोन विकसित करणे - गैरसमज दूर करणे, मोफत पॅड देणे आणि ग्रामीण महिलांसाठी स्वयंरोजगाराच्या संधी वाढविण्यासाठीचा अभिनव उपक्रम सहकार्य करा.  ",

    HP_hs_s5_h: "दृष्टी अभियान: ग्रामीण नेत्रआरोग्याची चळवळ  ",
    HP_hs_s5_desc:
      "ग्रामीण भागातील नागरिकांना मोफत अत्याधुनिक व दर्जेदार नेत्रसेवा देण्यासाठी अक्का फाऊंडेशनतर्फे 'दृष्टी अभियान' हा उपक्रम राबविण्यात येत आहे.",

    HP_as_heading: ", उद्देश सुखी जनजीवनाचा",
    HP_as_span: "संकल्प सर्वांगीण विकासाचा",
    HP_as_para:
      "गेल्या सात वर्षांपासून अक्का फाऊंडेशन ही कुटुंबिक जिव्हाळ्यातून विविध सेवाकार्य राबवत आहे. समाजाच्या सर्वांगीण विकासाचा संकल्प घेऊन समाजातील वंचित घटकांना विकासाच्या संधी, कौशल्ये आणि पूरक वातावरणाच्या माध्यमातून वंचितांना सक्षम करते. जलसुरक्षेपासून सांस्कृतिक संवर्धनापर्यंत स्वावलंबी आणि सुसंवादी समाजाच्या उभारणीसाठी संस्था सातत्याने प्रयत्न करत आहे.",
    HP_as_cta: "सहभागी व्हा ",

    HP_cs_heading: "चला थोडे सहकार्य करू, ",
    HP_cs_heading_span: "अनेकांचे जीवन सावरू ",
    HP_cs_pa_title: "प्रोजेक्ट आनंदी  ",
    HP_cs_pa_desc:
      "मासिक पाळीविषयी समाजात विशेषत: ग्रामीण भागामध्ये असलेले गैरसमज-अंधश्रद्धा दूर करून त्याविषयी सकारात्मक वातावरण तयार करण्यासाठी ‘प्रोजेक्ट आनंदी’ची सुरुवात करण्यात आली. यामध्ये मुली-महिलांसाठी मासिक पाळी व आरोग्यासंबंधी कार्यशाळा, चर्चासत्रे तसेच मोफत सॅनिटरी पॅड वाटप करून महिलांसाठी आरोग्यपूर्ण व्यवस्था उभी करण्यात प्रयत्न केले जात आहेत.",
    HP_cs_pa_current: "वर्तमान प्रगती",
    HP_cs_pa_target: "लक्ष्य",
    HP_cs_pa_cta: "आता दान करा",
    HP_cs_pa_learn: "अधिक जाणून घ्या",
    HP_cs_da_title: "दृष्टी अभियान ",
    HP_cs_da_desc:
      "ग्रामीण भागातील गरजू नागरिकांना नेत्रविषयक समस्यांवर मोफत अत्याधुनिक सुविधा मिळाव्या यासाठी अक्का फाऊंडेशनतर्फे या उपक्रमाची सुरुवात करण्यात आली आहे. ग्रामीण भारतातील डोळ्यांच्या समस्या, विशेषत: मोतीबिंदू यावर मोफत शस्त्रक्रिया,चष्मे आणि मार्गदर्शन केले जाते.",
    HP_cs_da_current: "वर्तमान प्रगती",
    HP_cs_da_target: "लक्ष्य",
    HP_cs_da_cta: "आता दान करा",
    HP_cs_da_learn: "अधिक जाणून घ्या",

    HP_as_title: "आपली कृती, करेल नव्या आदर्शांची निर्मिती ",
    HP_as_cta: "अधिक जाणून घ्या",
    HP_as_t1_title: "सक्षम महिला, सक्षम समाज",
    HP_as_t1_desc:
      "महिला व समाजातील दुर्बल घटकांच्या विकासातूनच समाजाचा विकास शक्य आहे. यासाठी महिला व दुर्बल घटकांना आर्थिक, शैक्षणिक, सामाजिक आणि सांस्कृतिक स्तरावर सक्षम करून समाजाच्या विकासामध्ये त्याची महत्त्वपूर्ण भूमिका पार पडण्यासाठी त्यांना प्रेरित केले जात आहे. यासाठी विविध उपक्रम व योजना संस्थेमार्फत राबविल्या जात आहेत.",
    HP_as_t2_title: "शिक्षणातून सुदृढ समाजनिर्मिती",
    HP_as_t2_desc:
      "देशाच्या भावी पिढीच्या उज्ज्वल भविष्यासाठी सर्वांना चांगले व दर्जेदार शिक्षण मिळणे गरजेचे आहे. समाजातील दुर्बल घटकंना शिक्षणाच्या समान संधी मिळवून देण्यासाठी देशाच्या भावी पिढीच्या उज्ज्वल भविष्यासाठी सर्वांना चांगले व दर्जेदार शिक्षण मिळणे गरजेचे आहे. समाजातील दुर्बल घटकंना शिक्षणाच्या समान संधी मिळवून देण्यासाठी अक्का फाऊंडेशन सातत्याने प्रयत्न करत आहे. विद्यार्थ्यांना मोफत शैक्षणिक साहित्याचे वाटप, प्रशिक्षण व मार्गदर्शन केंद्रांच्या माध्यमातून ही कार्य अखंडपणे सुरु आहेत. ",
    HP_as_t3_title: "निरोगी नागरिक, निरोगी राष्ट्र ",
    HP_as_t3_desc:
      "निरोगी नागरिक हे अक्का फाऊंडेशनचे ध्येय आहे. ग्रामीण भागातील नागरिकांना चांगल्या व दर्जेदार आरोग्य  सुविधा उपलब्ध करून देण्यासाठी अक्का फाऊंडेशनकडून सातत्याने प्रयत्न सुरु आहेत. विविध आरोग्य शिबिरे, रक्तदान शिबिरे, आपत्कालीन सुविधा, औषधे, आर्थिक तसेच शासकीय सुविधांच्या माध्यमातून दररोज अनेकांना नवजीवन प्रदान केले जात आहे.  ",
    HP_as_t4_title: "हरित भवितव्याकडे एक पाऊल ",
    HP_as_t4_desc:
      "पर्यावरणाचा ऱ्हास आणि ढासळत निघालेला समतोल हा अनेक संकटाना जन्म देत आहे. त्यामुळे पर्यावरण संवर्धनासाठी संस्था कायमच पुढाकार घेऊन कार्य करत आहे. पर्यावरण, अन्न सुरक्षा, पाणी आणि मृद संधारणावर संस्थेने लक्ष केंद्रित केले आहे. वृक्षारोपणापासून पुनर्वापरापर्यंत अनेक उपक्रमांच्या माध्यमातून हरित भविष्यासाठी प्रयत्न केले जात आहेत.",
    HP_as_t5_title: "संस्कृतीतून जनकार्याचा संस्कार  ",
    HP_as_t5_desc:
      "आपली उज्ज्वल संस्कृती समजून व आत्मसात करूनच भविष्याचा सुदृढ पाया घातला जाऊ शकतो. हा विश्वास मनात घेऊन अक्का फाऊंडेशन सांस्कृतिक क्षेत्रात कार्य करत आहे. ग्रामीण जीवनाचे केंद्र असलेल्या कला व संस्कृतीचे जतन करण्यासाठी अनेक अभिनव उपक्रम राबवले जात आहेत. संस्थेमार्फत राबविल्या जाणाऱ्या शिवजयंती उत्सवाची प्रतिवर्षी जगभरातून दखल घेतली जाते.    ",

    HP_og_title: "आनंदाचे क्षण:",
    HP_og_span: "  संस्थेच्या कार्यांची छायाचित्रातून सफर  ",
    HP_og_1: "फोटो गॅलरी ",
    HP_og_2: "व्हिडीओ स्टोरीस् ",
    HP_og_3: "बातम्या आणि दखल: संस्थेच्या कार्यांची माध्यमांनी घेतलेली दखल ",
    HP_og_4: "विविध उपक्रमांची क्षणचित्रे",

    HP_blog_title: "सकारात्मक विचारांसाठी",
    HP_blog_span: " ; अक्का फाउंडेशनचा ब्लॉग हब.",

    HP_ch_title: "एकमेका सहाय्य करू, अवघेची धरू सुपंथ!",
    HP_ch_cta: "आजच सहभागी व्हा",

    // awards page

    aw_title: "पुरस्कार आणि यश",
    aw_hc_title:"महाराष्ट्र रत्न पुरस्कार",
    aw_hc_span:"२०२५",
    aw_hc_desc:"'लोकमत ग्लोबल इकॉनॉमिक कन्व्हेन्शन २०२५' या सोहळ्यात 'अक्का फाउंडेशनला प्रतिष्ठेच्या महाराष्ट्र रत्न' पुरस्काराने गौरवण्यात आले. महाराष्ट्रभरात सामाजिक बांधिलकी आणि जनविकासासाठी फाउंडेशनने केलेल्या अविरत कार्याचा हा सन्मान आहे. श्रीमती रूपाताई पाटील निलंगेकर यांच्या विचारांतून आणि मूल्यांमधून अक्का फाउंडेशनची मुहूर्तमेढ रोवली गेली. महिला सक्षमीकरण, मासिक पाळीबाबत आरोग्य जनजागृती, शिक्षण आणि शाश्वत सामाजिक परिवर्तन यांसारख्या विषयांवर आम्ही २०१६ पासून सातत्याने काम करत आहोत. हा पुरस्कार म्हणजे केवळ आमचा सन्मान नसून, २०१६ पासून आमच्या कार्याशी जोडल्या गेलेल्या प्रत्येकाच्या कष्ट आणि निष्ठेचा सन्मान आहे. यामुळे समाजाप्रती असलेली आमची जबाबदारी अधिक वाढली असून, भविष्यात अधिक व्यापक स्तरावर काम करण्याची ऊर्जा आम्हाला मिळाली आहे.",
     aw_hc_ph_title:"कौतुकाची थाप आणि काही",
    aw_hc_ph_title_span:"खास क्षण",
    //// empower page

    EM_pt_title: "दुर्बलांचे सक्षमीकरण, हेच राष्ट्राचे सशक्तिकरण ",
    EM_hc_title: "मार्गदर्शन, क्षमता विकास आणि त्याद्वारे प्रगती",
    EM_hc_span: "",
    EM_hc_desc:
      "शाश्वत विकासाचे उद्दिष्ट हे वंचितांच्या सक्षमीकरणातूनच साध्य होणार आहे. त्यामुळे आर्थिक आणि सामाजिक आव्हानांना सामोरे जाणाऱ्यांना शाश्वत संधी, प्रेरणा आणि विकासासाठी आवश्यक असलेली संसाधने प्रदान करणे आवश्यक आहे. कौशल्य विकासाची जोपासना करून आणि आर्थिक पाठबळ देऊन शाश्वत भविष्यासाठी व्यक्तींना स्वावलंबी बनविण्याचे अक्का फाउंडेशनचे उद्दिष्ट आहे. यासाठी वंचित घटकांना स्वातंत्र्य, आर्थिक सुरक्षा, कौटुंबिक पाठबळ याबरोबर त्यांचा आत्मविश्वास वाढविण्यावर भर दिला जातो. संस्थेकडून ग्रामीण भागाच्या शाश्वत विकासावर लक्ष केंद्रित करून दारिद्र्य निर्मूलनाच्या संधी आणि अडथळे यांचा शोध घेतला जातो. शेती, सेवा आणि उत्पादन यांसारखी परस्परसंलग्न क्षेत्रांशी जोडून त्यांच्या उत्थानाकडे लक्ष दिले जाते. कौशल्य प्रशिक्षणापासून पुनर्वसन कार्यक्रमांपर्यंत सामाजिक, शैक्षणिक आणि आर्थिक सक्षमीकरणासाठी प्रयत्न केले जाते. वंचितांचे सक्षमीकरण केवळ तात्कालिक गरजा पूर्ण करून नाही तर दीर्घकालीन शाश्वत उपायांनीच शक्य आहे. या सर्व घटकांमध्ये स्वावलंबन निर्माण करून त्यांच्या शाश्वत विकासाला प्रोत्साहन देत अधिक समतामूलक आणि विकासाभिमुख समाज तयार करण्याचा प्रयत्न अक्का फाऊंडेशन करत आहे.",

    EM_id1_title: "नारी ते",

    EM_id1_span: "नारायणी...",
    EM_id1_desc:
      "महिला हा समाजाचा प्रमुख आधार आहे. त्यामुळे त्यांना अधिकाधिक स्वावलंबी बनविणे, हाच त्यांच्या सशक्तीकरणाचा खरा मार्ग आहे, असे आम्ही मानतो. समाजाच्या गरजू तसेच दुर्बल घटकातील महिलांना कौशल्य विकासातून तसेच बचत गटांच्या माध्यमातून आर्थिकदृष्ट्या सबळ बनविण्यासाठी, अक्का फाऊंडेशन कार्य करत आहे. लातूर जिल्ह्यामध्ये संस्थेमार्फत अनेक बचत गट चालवले जात असून त्यांना संस्थात्मक तसेच विविध सरकारी योजनांमधून लाभ मिळवून दिला जात आहे. ",

    EM_id2_title: "स्वावलंबी",
    EM_id2_span: "‘ती’ ",

    EM_id3_card1_title: " कौशल्य विकासाद्वारे महिलांचे सक्षमीकरण:",
    EM_id3_card1_desc:
      "‘व्यावसायिक प्रशिक्षणातून ग्रामीण महिलांचे स्वावलंबन’ हा मुख्य हेतू या कार्यामधून साधला जातो. निलंगा तालुक्यासह लातूर जिल्ह्यातील इतर भागांमधील महिलांना विविध कार्यशाळांमधून व्यावसायिक प्रशिक्षण दिले जाते. तसेच नवीन व्यवसायासाठी मार्गदर्शन व सहकार्य केले जाते.",
    EM_id3_card2_title: "महिला बचत गट: महिला अर्थकारणाचे नवे केंद्र",
    EM_id3_card2_desc:
      "ग्रामीण भागातील महिलांना एकत्र करून ‘बचतीतून आर्थिक स्वावलंबन’ हा उद्देश यामाध्यमातून साधला जातो. बचत गटांच्या माध्यमातून महिलांना आपल्या मासिक खर्चातून बचतीची सवय लागते. तसेच एकत्रितपणे केलेली बचत व परस्पर सहकार्याने अनेक महिलांना याचा फायदा झालेला आहे. विशेषतः नवीन उद्योग उभारण्यासाठी यातून मोठा फायदा महिला वर्गाला झालेला आहे. या बचतगटांमधून आजपर्यंत जवळपास ५ हजार महिला भगिनींना प्रत्यक्ष व अप्रत्यक्षपणे लाभ मिळाला आहे.",

    EM_id4_left_title: "संवेदना:  ",
    EM_id4_left_span: "स्वावलंबी दिव्यांग  ",
    EM_id4_left_desc:
      "समाजातील अत्यंत खडतर आयुष्य जगणारे आणि सर्वात जास्त उपेक्षित असलेला घटक म्हणजे दिव्यांग बांधव. दिव्यांग नागरिकांचे आयुष्य सुगम व समृद्ध बनावे, तसेच त्यांना आत्मनिर्भर बनविण्यासाठी अक्का फाऊंडेशनतर्फे ‘संवेदना’ या अभिनव उपक्रमाची सुरुवात करण्यात आली आहे. या उपक्रमाअंतर्गत लातूर जिल्ह्यातील दिव्यांग नागरिकांची नोंदणी करून त्यांना आवश्यक साहित्यांचे मोफत वितरण तसेच रोजगारसंधी उपलब्ध करून दिली जात आहे. याचबरोबर दिव्यांग नागरिकांसाठी असलेल्या शासकीय योजनांचा लाभ मिळवून देण्यासाठी प्रयत्न केले जातात.",

    EM_id4_right_title: "संवेदना उपक्रमाअंतर्गत  ",
    EM_id4_right_span: " झालेले कार्य: ",
    EM_id4_right_para1: " दिव्यांग नागरिकांना सरकारी योजनांचा लाभ  ",
    EM_id4_right_para2: " नागरिकांना मोफत साहित्यवाटप",

    EM_id5_title: " एक हात मदतीचा... ",
    EM_id5_span: "जगाच्या पोशिंद्यासाठी",

    EM_id6_card1_title: "शेतीसाहित्यांचे वाटप :",
    EM_id6_card1_desc:
      "सर्व जगाच्या अन्नाची गरज भागविणाऱ्या बळीराजाला येणाऱ्या अडचणी दूर करण्यासाठी ‘अक्का फाऊंडेशन’ मार्फत गरजू शेतकरी बांधवांना आवश्यक त्या सर्व साहित्यांचा पुरवठा केला जातो. शेतीसाठी लागणारे बियाणे, शेती साहित्य, मार्गदर्शन तसेच आवश्यक पडल्यास आर्थिक सहाय्य संस्थेकडून दिले जाते. आजपर्यंत संस्थेकडून १५०० हून अधिक शेतकरी बांधवांना मदत करण्यात आली आहे.",

    EM_id6_card2_title: "आत्महत्याग्रस्त शेतकरी कुटुंबांना पशुधनाचे वाटप :",
    EM_id6_card2_desc:
      "शेतकरी आत्महत्या हा आपल्या समाजाला लागलेला सर्वात मोठा अभिशाप आहे. महाराष्ट्रामध्ये शेतकरी आत्महत्यांचे प्रमाण अत्यंत भयावह असून अशा कुटुंबांना मदत करणे हे आपल्या सर्वांचे कर्तव्य आहे. याच कौटुंबिक भावनेतून संस्थेकडून आत्महत्याग्रस्त शेतकरी बांधवांना उपजीविकेसाठी पशुधनाचे वाटप केले जाते. ",

    EM_id6_card3_title: "विविध योजना व मदतींचा लाभ:",
    EM_id6_card3_desc:
      "याचबरोबर शेतकरी बांधवांसाठी कार्यरत असलेल्या विविध संस्था तसेच सरकारी मदत मिळवून देण्यासाठी देखील संस्थेमार्फत कायम मदत केली जाते. संस्थेच्या स्वयंसेवकांमार्फत याविषयी शेतकरी बांधव व त्यांच्या कुटुंबियांना आवश्यक ते मार्गदर्शन व सहकार्य केले जाते. ",



    EM_is_title: "फुलवूया आनंदाचे क्षण...",



    // environment-----------page---------

    ENP_pt_title: "पर्यावरण संवर्धन",

    ENP_hc_title: "चला घडवू सुजलाम् सुफलाम्’ ",
    ENP_hc_span: "हरित भविष्य!",
    ENP_hc_desc:
      "पर्यावरण हा प्रत्येकाच्या जगण्याचा आधार आहे. ग्रामीण विकास साधत असताना, यामध्ये पर्यावरणाकडे दुर्लक्ष करता येणे शक्य नाही. पर्यावरणीय असमतोलामुळे निर्माण झालेल्या वातावरणीय बदलांचा सर्वाधिक फटका हा ग्रामीण भागातील पर्जन्याला बसत आहे. त्यातही मराठवाडा आणि विदर्भासारख्या दुष्काळप्रवण भागात ही परिस्थिती अधिक भयानक स्वरूप घेत आहे. त्यामुळे अक्का फाऊंडेशन पर्यावरण संवर्धनाविषयी अधिक सजगतेने कार्य करत असून नागरिक आणि निसर्ग त्यांच्यामध्ये सहचार्य साधण्याचा प्रयत्न संस्थेमार्फत केला जात आहे. पर्यावरणाचे रक्षण व योग्य संवर्धन केल्यास अनेक सामाजिक व नैसर्गिक समस्यांचे निराकरण होऊ शकते, यावर भर देऊन जनसहभागातून पर्यावरणपूरक कृती करण्याकडे लक्ष दिले जाते. ज्यामध्ये वृक्षलागवड, सार्वजनिक वनीकरण, कचरा व्यवस्थापन, जल आणि मृदा संवर्धन, प्रदूषण नियंत्रणासाठी प्रयत्न व नागरिकांमध्ये पर्यावरणाविषयी जागरूकता घडविणे. लातूर आणि  मराठवाड्यासारख्या दुष्काळग्रस्त भागांमध्ये पर्यावरणपूरक कृती अनेक व्यापक बदल घडवू शकतात. त्यामुळे पर्यावरणाविषयी जागरूक आणि निसर्गाशी एकरूप समाज व्यवस्था उभी करण्याच्या दृष्टीने अक्का फाऊंडेशन प्रयत्न करत आहे.",

    ENP_is1_title: "वृक्षवल्ली आम्हा ",
    ENP_is1_span: "सोयरे",
    ENP_is1_desc:
      "मानवी जीवन व पर्यावरणातील वृक्षांचे महत्त्व हे अनन्यसाधारण आहे. त्यामुळे ‘वृक्ष लागवड व संगोपन’ हा संस्थेचा सर्वात आवडता नित्यउपक्रम आहे. थोर महापुरुषांच्या जयंती, विविध सामाजिक उपक्रम तसेच संस्थेच्या वर्धापन दिनी संस्थेकडून मोठ्या प्रमाणात वृक्ष लागवड केली जाते. तसेच त्या वृक्षांच्या संवर्धनाची प्रतिज्ञा स्वयंसेवकांकडून केली जाते. याचबरोबर विविध सामाजिक संस्थांना देखील वृक्ष लागवडीसाठी संस्थेकडून प्रेरित केले जाते.",
    ENP_is1_line1: "वृक्षांची लागवड व जतन",
    ENP_is1_para2: "वृक्ष लागवडीचा मंत्र, पर्यावरण रक्षणाचे हेच तंत्र!",

    ENP_is2_title: "जलरक्षण,",
    ENP_is2_span: "जीवनरक्षण",

    ENP_is3_title: "इंद्रप्रस्थ जलभूमी अभियान: ",
    ENP_is3_span: "लातूरची ‘जलसंजीवनी'",
    ENP_is3_desc1:
      "लातूरसह मराठवाड्याला ‘दुष्काळमुक्त’ करून ‘जलयुक्त’ करण्याच्या उद्देशाने अक्का फाऊंडेशनद्वारे दि. २२ मे ते ५ जून २०१८ दरम्यान संपूर्ण लातूर जिल्ह्यात ‘इंद्रप्रस्थ जलभूमी अभियान’ राबविण्यात आले. संपूर्ण जिल्ह्यात नागरिकांना घरोघरी जाऊन जलरक्षणाचे महत्त्व सांगून त्याविषयी प्रशिक्षण देण्यात आले. पावसाचे पाणी अडवून जमिनीत मुराविण्यासाठी खड्डे, चर खोदण्यात आले. यासाठी लागणाऱ्या साहित्यांचे मोफत वाटप तसेच श्रमदानाच्या माध्यमातून अभियानाअंतर्गत जिल्ह्यात २८०० बोअरवेल्स, विहिरींचे पुनर्भरण करण्यात आले. यामुळे जिल्ह्याच्या भूजलपातळीत ८ मीटरची लक्षणीय वाढ नोंदवली गेली. ज्याचे सर्व स्तरातून कौतुक झाले.",
    ENP_is3_desc2: "",
    ENP_is3_desc3: "",

    ENP_is4_card1_title: "अभियानाची वैशिष्ट्ये",
    ENP_is4_card1_li1: "९४५ गावांमध्ये प्रकल्पाच्या माध्यमातून कार्य ",
    ENP_is4_card1_li2: "घराघरातील नागरिकांना जलरक्षणाविषयी प्रशिक्षण ",
    ENP_is4_card1_li3: "घरोघरी वृक्षवाटप",
    ENP_is4_card1_li4: "स्वच्छता मोहिमांचे आयोजन",
    ENP_is4_card1_li5:
      "प्रशिक्षण पूर्ण केलेल्या नागरिकांना ‘जलयोद्धा’ ही पदवी ",

    ENP_is4_card2_title: "पंचनिष्ठा",
    ENP_card2_li1_is4: "धावणाऱ्या पाण्याला चालवायचे",
    ENP_is4_card2_li2: "चालणाऱ्या पाण्याला थांबवायचे",
    ENP_is4_card2_li3: "थांबलेल्या पाण्याला जमिनीत मुरवायचे",
    ENP_is4_card2_li4: "पडणाऱ्या पाण्याचे पुनर्भरण",
    ENP_is4_card2_li5: "झाडे लावा, झाडे जगवा ",

    ENP_is5_title: "जलयुक्त शिवार :  ",
    ENP_is5_span: " जलसमृद्ध आवार",
    ENP_is5_desc:
      "‘सत्कार्याला सहकार्य’ ही अक्का फाऊंडेशनची आणखी एक कार्यपद्धत. जलसंरक्षण क्षेत्रात आमुलाग्र बदल घडविणारी महाराष्ट्र शासनाची एक महत्त्वकांक्षी योजना म्हणजे ‘जलयुक्त शिवार अभियान’. लातूरकरांच्या जीवनात ‘जलसमृद्धी’ आणणाऱ्या या अभियानात ‘अक्का फाऊंडेशन’ने हिरिरीने सहभाग नोंदवून संपूर्ण जिल्हाभर हे अभियान यशस्वी करण्यासाठी योगदान दिले.",

    ENP_fi_title: "हरित भविष्याचे ",
    ENP_fi_span: "साक्षीदार",

    // health page------------------------------

    HEP_pt_title: "आरोग्यम् धनसंपदा",

    HEP_hc_title: "निरोगी ",
    HEP_hc_span: "आयुष्यासाठी",
    HEP_hc_desc:
      "आरोग्य ही सर्वात मोठी संपत्ती आहे. निरोगी व सुदृढ नागरिक हेच एका सुदृढ राष्ट्राची निर्मिती करू शकतात. त्यामुळे आरोग्याला प्राधान्य देणे हा अक्का फाऊंडेशनच्या वंचित घटकांच्या शाश्वत विकासाच्या उद्दिष्टातील एक महत्त्वपूर्ण पैलू आहे. ग्रामीण भागामध्ये आर्थिक अडचणी व आधुनिक साधनांच्या अनुपलब्धतेमुळे गरीब नागरिकांना चांगली आरोग्य सुविधा उपलब्ध होत नाहीत. त्यामुळे टाळले जाऊ शकणारे अनेक आजार हे उपचार उपलब्ध नसल्यामुळे गंभीर रूप घेतात. याचा सर्वाधिक फटका हा लहान मुले, महिला व वृद्ध नागरिकांना बसतो व परिणामी त्या घराची वाताहत होते. त्यामुळे आरोग्य क्षेत्रात वंचित घटकांसाठी चांगल्या सुविधा उपलब्ध करून दिल्यास याचा त्यांना सर्वाधिक फायदा होऊन बहुआयामी मार्गांनी शाश्वत विकासास हातभार लागतो. निरोगी लोकसंख्या ही अधिक उत्पादनक्षम असते, ज्यामुळे आर्थिक विकास होतो आणि गरिबीचे चक्र मोडते. त्यामुळे अक्का फाऊंडेशन यासाठी विशेष लक्ष देत आहे. नियमित तपासणी, आपत्कालीन सेवा आणि जागरूकता मोहिमांच्या माध्यमातून निरोगी समाज उभारण्यासाठी प्रयत्न केले जात आहेत. समाजातील प्रत्येक घटकाला चांगल्या आरोग्य सेवेच्या माध्यमातून निरोगी व निरामय जीवन जगता यावे, यासाठी अक्का फाऊंडेशन कायम कटिबद्ध आहे.",

    HEP_is1_card1_title: " रक्तदान, श्रेष्ठ दान ",
    HEP_is1_card1_desc:
      "वैद्यकीय क्षेत्रामध्ये दररोज अनेक रुग्णांना रक्ताची आवश्यकता पडते. रुग्णांची हीच गरज लक्षात घेऊन ‘अक्का फाऊंडेशन’ तर्फे मोठ्या प्रमाणात रक्तदान शिबिरांचे आयोजन केले जाते. महापुरुषांच्या जयंती, जागतिक दिनविशेष तसेच संस्थेच्या वर्धापन दिनी रक्तदान शिबिरे राबवली जातात. संस्थेमार्फत आजपर्यंत ५० हून अधिक शिबिरांचे यशस्वी आयोजन करण्यात आले असून ७ हजार नागरिकांनी या शिबिरांमध्ये रक्तदान केले आहे.",

    HEP_is1_card2_title: "महाआरोग्य शिबीर",
    HEP_is1_card2_desc:
      "ग्रामीण भागातील नागरिकांच्या परिपूर्ण आरोग्यासाठी संस्थेमार्फत विविध आरोग्य शिबिरांचे आयोजन केले जाते. यामध्ये आजपर्यंत १ लाखाहून अधिक नागरिकांची मोफत आरोग्य तपासणी करण्यात आली आहे. तसेच १० हजार नागरिकांवर कायमस्वरूपी मोफत उपचार करण्यात आले आहेत.",

    HEP_is1_card3_title: "कोरोनाविरोधातील यशस्वी लढा",
    HEP_is1_card3_desc:
      "कोरोना (COVID-19) मानवी इतिहासातील एक भयाण पर्व. चीनच्या वूहान शहरात आढळलेल्या या छोट्याशा विषाणूने अवघ्या जगाचा व्यवहार ठप्प पाडला होता. अनेक नागरिकांचे प्राण घेतलेल्या या आजाराने मानवी जीवन पूर्णपणे विस्कळीत केले होते. दरम्यान मानवताधर्माचे पालन करत, ‘अक्का फाऊंडेशन’ने जनसेवेसाठी आपल्या परिने अनेक प्रयत्न करत नागरिकांना मदत केली. ",

    HEP_is2_card1_title: "कोरोना काळातील कार्य : ",
    HEP_is2_card1_li1: " कोरोना काळामध्ये २५ हजार गरजू नागरिकांना अन्नवाटप",
    HEP_is2_card1_li2:
      "छोटे व्यावसायिक, गरिब रुग्ण व त्याचे नातेवाईक यांना अन्नछत्राद्वारे भोजन वितरण",
    HEP_is2_card1_li3:
      "रुग्णालयांना ५ बायपॅप व्हेंटिलेटर्स, ३० ऑक्सिजन काँन्सेन्ट्रेटर्सचे वितरण.",
    HEP_is2_card1_li4: "१०० हून अधिक खाटांच्या कोविड केअर सेंटरची उभारणी.",
    HEP_is2_card1_li5:
      "तिसऱ्या लाटेविषयी तज्ञांनी व्यक्त केलेल्या शक्यतेनंतर अक्का फाऊंडेशनच्या माध्यमातून लहान मुलांसाठी स्वतंत्र ‘एनआयसीयू’ची उभारणी.",
    HEP_is2_card1_li6:
      "कोरोना रुग्णांना सर्वोपरी मदत मिळावी यासाठी वॉर रूम, नागरिकांना सॅनिटायझर व आर्सेनिक अल्बमचे वाटप, रक्ताचा तुटवडा भासू नये यासाठी रक्तदान शिबिरांचे आयोजन.",
    HEP_is2_card1_li7:
      "ऑक्सिजन निर्मिती प्रकल्प उभारण्याकरिता साखर कारखान्यांना प्रोत्साहन.",

    HEP_is2_card2_title: " लसीकरण टास्कफोर्स : ",
    HEP_is2_card2_span: "दिव्यांगांसाठी वरदान",
    HEP_is2_card2_desc:
      "अक्का फाऊंडेशनद्वारे कोरोना लसीकरणादरम्यान स्वयंसेवी संस्थेमार्फत राबविण्यात आलेला ‘टास्कफोर्स’ कार्यक्रम हा बहुदा राज्यातील पहिला व एकमेव उपक्रम आहे. या उपक्रमाअंतर्गत ८०० स्वयंसेवकांनी नागरिकांच्या घरोघरी जाऊन त्यांचे लसीकरण केले. विशेषतः दिव्यांग नागरिकांना याचा मोठा फायदा झाला.",
    HEP_is2_card2_desc2:
      "या टास्कफोर्सच्या माध्यमातून जवळपास १२,००० दिव्यांग नागरिकांचे लसीकरण करण्यात आले. तसेच याची आणखी एक उपलब्धी म्हणजे देवणी तालुक्यातील नागतीर्थवाडी हे मराठवाड्यातील पहिले व राज्यातील दुसरे १०० टक्के लसीकरण झालेले गाव ठरले. या टास्कफोर्सविषयी माहिती व प्रोत्साहान देण्याकरिता राज्याचे उपमुख्यमंत्री मा.श्री. देवेंद्रजी फडणवीस यांनी आभासी पद्धतीने (VC) संवाद साधून संस्थेच्या या उपक्रमाचे कौतुक केले होते.",

    HEP_fi_title: "निरामय ",

    // art----------culture-------------
    AC_pt_title: "आपली संस्कृती, आपली ओळख",

    AC_hc_title: "संस्कृतीतून",
    AC_hc_span: "आधुनिकतेकडे",
    AC_hc_desc:
      "आपली संस्कृती ही अत्यंत समृद्ध व सर्वसमावेशक आहे. विशेषतः ग्रामीण जनजीवन हे कला आणि संस्कृतीशी एकरूप झालेले आहे. सामाजिक जीवनामध्ये कला-संस्कृतीचे असलेले स्थान तसेच त्याद्वारे घडणारा मानवविकास लक्षात घेऊन अक्का फाऊंडेशन कला व सांस्कृतिक क्षेत्रामध्ये विविध उपक्रमांचे आयोजन करते. आपल्या देशात अनेक महापुरुष होऊन गेले आहेत. ज्यांनी या देशाच्या विकासासाठी व जनतेच्या कल्याणासाठी आपले संपूर्ण आयुष्य पणाला लावले. आधुनिकतेचा स्वीकार करत असताना आपला इतिहास आणि संस्कृतीचा विसर पडू नये यासाठी तसेच या सर्व महापुरुषांचे स्मरण करून त्यांच्या कार्यातून भावी पिढीला नित्य प्रेरणा मिळावी, यासाठी संस्थेमार्फत विविध सांस्कृतिक व सामाजिक कार्यांचे दरवर्षी आयोजन केले जाते. या कार्यक्रमांमधून फक्त इतिहासाचे जतन न होता, विचारांची आणि संस्कृतीची देवाण-घेवाण होते. विविधेतील एकता जपत नागरिकांचा सहभाग वाढून परस्पर सौदाहार्य व बंधुत्व भाव वाढीस लागतो. संस्थेमार्फत दरवर्षी साजऱ्या होणाऱ्या शिवजयंती उत्सवाची संपूर्ण जगभरातून दखल घेतली जाते. यावेळी राबविण्यात येणाऱ्या अनेक सामाजिक व कलात्मक उपक्रमांची ‘गिनीज वर्ल्ड ऑफ रेकॉर्ड’ मध्ये नोंद करण्यात आलेली आहे. भव्य, सांस्कृतिक, सामाजिक व राष्ट्रीयत्व जपत बंधुभाव वाढवणारे हे उपक्रम अक्का फाऊंडेशनच्या पुढाकारातून घडत असून एका सुदृढ समाजाच्या निर्मितीमध्ये आपले योगदान देत आहेत.",

    AC_is1_title: "विश्वविक्रमी ",
    AC_is1_span: "शिवजयंती ",
    AC_is1_desc:
      "छत्रपती शिवाजी महाराज हे संपूर्ण विश्वासाठी एक आदर्श व्यक्तिमत्व आहे. सदासर्वदा त्यांच्या चरित्राचे पारायण करावे, असे थोर जीवित कार्य त्यांनी केले. रयतेचे हक्काचे राज्य स्थापून आदर्श राज्यव्यवस्था त्यांनी निर्माण केली. महाराजांचा हाच पराक्रमी इतिहास व त्यांचा आदर्श जगापर्यंत पोहोचावा, या उद्देशाने अक्का फाऊंडेशनतर्फे दरवर्षी अभिनव संकल्पनांसह विश्वविक्रमी शिवजयंती साजरी करून महाराजांना मानवंदना दिली जाते.",

    AC_slider1_title: "वर्ष २०१८ :",
    AC_slider1_span: "छत्रपती शिवरायांची विश्वविक्रमी रांगोळी ",
    AC_slider1_li1:
      " ५० हजार किलोग्रॅम रांगोळीचा वापर करून छत्रपती शिवरायांची सिंहासनारूढ प्रतिमा.",
    AC_slider1_li2:
      "अडीच एकर जागेवर तब्बल १ लाख ११ हजार ८४३ स्के.फूटांची प्रतिमा.",
    AC_slider1_li3: " दीड लाख नागरिकांनी दिली भेट.",

    AC_slider2_title: "वर्ष २०१९ : ",
    AC_slider2_span: "हरित शिवजन्मोत्सव ",
    AC_slider2_li1:
      " पर्यावरण व शेती याविषयी जागृती करिता हरित शिवजन्मोत्सवाची संकल्पना.",
    AC_slider2_li2:
      "हरित धान्यांच्या माध्यमातून ६ एकर शेतीमध्ये जिवंत रोपांद्वारे साकारली शिवप्रतिमा. ",
    AC_slider2_li3: "तब्बल २ लाख ४० हजार स्के.फूटांचा भव्य विस्तार.",
    AC_slider2_li4: "जगातील एकमेव हरित प्रतिमा.",
    AC_slider2_li5: "गुगल मॅपवरून ही प्रतिमा दर्शन. ",
    AC_slider2_li6: "महाराष्ट्रसह जगभरातील माध्यमांनी घेतली दखल.",

    AC_slider3_title: "वर्ष २०२० ",
    AC_slider3_span: "शिवसंकल्प दुष्काळमुक्तीचा ",
    AC_slider3_desc:
      "संकल्प हेच कार्यसिद्धीचे मूळ आहे. छत्रपती शिवरायांनी देखील हिंदवी स्वराज्य स्थापनेची सुरुवात ही ‘संकल्पा’पासूनच केली. रोहिडेश्वराच्या पिंडीवर आपल्या रक्ताचा अभिषेक करत महाराजांनी हिंदवी स्वराज्याची प्रतिज्ञा घेतली. महाराजांच्या या कृतीतून प्रेरित होऊन २०२० मध्ये ‘शिवसंकल्प’ हा अभिनव उपक्रम राबवत ‘शिवजयंती’ साजरी केली गेली. ",

    AC_slider4_title: "वर्ष २०२१: ",
    AC_slider4_span: "सांस्कृतिक शिवजन्मोत्सव ",
    AC_slider4_li1:
      " कोरोनाच्या पार्श्वभूमीवर दोन दिवसीय सांस्कृतिक कार्यक्रमांचे आयोजन.",
    AC_slider4_li2:
      "कोरोनापासून रक्षणा करिता मास्क आणि हॅन्ड सॅनिटायझरचे वाटप.",
    AC_slider4_li3:
      "शिवजयंतीच्या पूर्वसंध्येला ‘शिवगर्जना’ या प्रसिद्ध गीतकार व गायक अवधूत गुप्ते संगीत रजनीचे आयोजन.",
    AC_slider4_li4:
      "शिवजयंती दिनी (१९ फेब्रु.) शिवअभिषेक व हेलिकॉप्टरद्वारे पुष्पवृष्टी.",
    AC_slider4_li5:
      "प्रसिद्ध सिनेकलाकार भरत जाधव यांच्या ‘सही रे सही’ या नाटकाचा प्रयोग.",
    AC_slider4_li6:
      "कोरोनाच्या सर्व नियमांचे पालन करून सर्व कार्यक्रम शिस्तबद्धपणे साजरे.",

    AC_slider5_title: "वर्ष २०२२ :   ",
    AC_slider5_span: "शाश्वत शिवजयंती",
    AC_slider5_li1:
      " सेवाकार्य हेच शाश्वत आहे, हाच विचार मनात घेऊन ‘शाश्वत शिवजयंती’ची संकल्पना.",
    AC_slider5_li2:
      "यंदाचे आकर्षण : सुमारे ११,००० चौरस फूट आकाराचे छत्रपती शिवरायांचे विश्वविक्रमी तैलचित्र.  ",
    AC_slider5_li3: "गिनीज बुक ऑफ वर्ल्ड रेकॉर्डमध्ये तैलचित्राचे नोंदणी.",
    AC_slider5_li4:
      "४५० लिटर ऑईल कलर आणि वॉर्निश कोटिंग करून १६ दिवसांमध्ये हे अतिभव्य तैलचित्र साकारण्यात आले. ",
    AC_slider5_li5:
      "शिवजयंतीनिमित्त ‘रक्तदान महायज्ञा’चे आयोजन. ५८५ मावळ्यांनी केले रक्तदान.",
    AC_slider5_li6:
      "निलंगा येथील शिवाजी चौकाचा उल्लेख ‘छत्रपती शिवाजी महाराज चौक’ असा व्हावा, यासाठी नवीन नामफलकाचे अनावरण.",
    AC_slider5_li7:
      "वैचारिक बैठकीसाठी प्रख्यात शिवव्याख्याते शिवश्री प्रा. गंगाधर बनबरे यांचे 'लढाया पलीकडील छत्रपती शिवराय' या विषयावरील अभ्यासपूर्ण व्याख्यान.",
    AC_slider5_li8:
      "निलंगा मतदारसंघातील प्रत्येक ग्रामपंचायत तसेच सेवाभावी संस्थांच्या माध्यमातून वृक्षारोपण.",

    AC_slider6_title: "वर्ष २०२३: ",
    AC_slider6_span: "जिजाऊवंदन शिवजन्मोत्सव ",
    AC_slider6_li1:
      " स्त्री हीच नवसृजनाची जननी आहे. छत्रपती शिवरायांच्या स्वराज्य स्थापनेची मूळप्रेरणा म्हणजे राजमाता जिजाऊ साहेब. समाजातील स्त्रीशक्तीमध्ये जागृती घडवून घरोघरी जिजाऊ घडविण्याचा संकल्प घेऊन ‘जिजाऊवंदन शिवजन्मोत्सवा’ची संकल्पना.",
    AC_slider6_li2:
      "यंदाचे आकर्षण : ८१ हजार ३९३ स्क्वे. फूटांचे छत्रपती शिवरायांच्या प्रतिमेचे क्रॉप आर्ट.   ",
    AC_slider6_li3:
      "प्रसिद्ध व्याख्यात्या डॉ. नंदाताई पाटील यांचे ‘मी जिजाऊ बोलतेय’ या विषयावर व्याख्यान.",

    AC_slider7_title: "वर्ष २०२४: ",
    AC_slider7_span: "शिवज्योत जन्मोत्सव",
    AC_slider7_li1: "तब्बल ४ लाख चौ.फुटावर साकारले भव्य दिव्य फायर आर्ट. ",
    AC_slider7_li2: " २५०० किग्रा मार्किंग रोप आणि १०० श्रमवीरांकडून कार्य.",
    AC_slider7_li3:
      "छत्रपती शिवरायांचे आजपर्यंतचे जगातील सर्वात मोठे 'फायर आर्ट' .",

    AC_slider_left_before_fi_title: "भारतरत्न डॉ. बाबासाहेब आंबेडकर जयंती",
    AC_slider_left_before_fi_desc:
      "भारतरत्न डॉ. बाबासाहेब आंबेडकर हे ज्ञान, एकता व राष्ट्रभक्तीची अभिव्यक्ती आहे. बाबासाहेबाचे कार्य व त्यांचे विचार हे संपूर्ण समाजाला एक नवी दिशा देणारे आहेत. बाबासाहेबांचे हे कार्य अधिकाधिक लोकांपर्यंत पोहोचावे, यासाठी त्यांच्या जयंतीदिनी संस्थेमार्फत विविध सामाजिक उपक्रमांचे आयोजन केले जाते. ",

    AC_slider_right_before_fi_title: "विचारधारा ",
    AC_slider_right_before_fi_desc:
      "डॉ. बाबासाहेब आंबेडकरांचे विचार तरुण पिढीपर्यंत पोहोचावे, यासाठी कोरोना काळात ‘विचारधारा’ या ऑनलाईन निबंधस्पर्धेचे आयोजन करण्यात आले होते. या स्पर्धेत राज्यभरातून ५ हजार स्पर्धकांनी सहभाग नोंदवला. यातील विजयी स्पर्धकांना संस्थेमार्फत पारितोषिक देऊन त्यांचा गौरव करण्यात आला. तसेच यातील निवडक निबंधांना संग्रहित करून त्याला पुस्तकाचे स्वरूप देण्यात आले आहे.",

    AC_fi_tile: "विचार, ",
    AC_fi_tile_span: " आचार आणि संस्कार ",

    //water conservation
    w_c_title: "जल साक्षरता रॅली",
    w_c_subtitle: "थेंब थेंब वाचवूया, ",
    w_c_span: "भविष्यासाठी साठवूया! ",
    w_c_desc:
      "लातूर जिल्ह्यातील ७५ टक्क्यांपेक्षा जास्त लोकांची उपजीविका ही शेतीवर अवलंबून आहे. जिल्ह्यातील जवळपास ८ लाख एकर क्षेत्र हे कोरडवाहू आहे. त्यात लातूर जिल्हा हा जलतुटीच्या (म्हणजे कमी पाण्याच्या) क्षेत्रात असल्यामुळे पठारी प्रदेश, जंगलांची कमतरता आणि पर्यावरणीय बदलांमुळे पाऊसाचे कमी अधिक प्रमाण यासर्वांमुळे दरवर्षी जिल्ह्याला तीव्र पाणीटंचाईचा सामना करावा लागतो. साहजिकच पिण्यासाठी आणि शेतीसाठीच पाणी अपुरे पडत असेल तर उद्योगांसाठी पाणी उपलब्ध होणार कोठून? याचा परिणाम म्हणूनच आज लातूरमधून मोठ्या प्रमाणात लोकांचे विशेषतः तरुण पिढीचे स्थलांतर होत आहे. जिल्ह्यात मोठ्या प्रमाणात गावे ओस पडत आहेत. हे सर्व रोखून लातूरच्या हक्काचे पाणी मिळवणे, जे आहे त्याचा योग्य आणि पुरेपूर वापर करणे, पावसाच्या पाण्याचा कोसळणारा प्रत्येक थेंब जतन करून त्याचा वापर करणे या सर्व गोष्टींविषयी नागरिकांना जागृत आणि प्रशिक्षित करण्यासाठीच 'जल साक्षरता रॅली'चे आयोजन करण्यात आले होते.  ",
    w_c_n_title: "रॅलीची ",
    w_c_n_title1: "वैशिष्टे:",
    w_c_n_text: "१९ सप्टेंबर ते २६ सप्टेंबर २०२३",
    w_c_n_text1: "८ दिवस ",
    w_c_n_text2: "१० तालुके  ",
    w_c_n_text3: "१,२८७ कि.मी. बाईक प्रवास.",
    w_c_n_text4: "३५४ गावांना भेटी ",
    w_c_n_text5: "४८२ ग्रामपंचायतींचा पाठिंबा.",
    w_c_n_text6: "१,०२५ गणेश मंडळांचे समर्थन पत्र.",

    w_c_slider_title: "समुद्रात वाहून जाणारे ",
    w_c_slider_span: " लातूरच्या हक्काचे पाणी मिळवणे.",
    w_c_slider_text1:
      "अरबी समुद्रामध्ये वाहून जाणारे १६७ टीएमसी पाणी हे मराठवाड्याला देण्याचे राज्य सरकारने घोषित केले आहे. हे सर्व पाणी गोदावरी मार्गे मराठवाड्याला येणार आहे.  ",
    w_c_slider_text2:
      "दरम्यान यामध्ये लातूरच्या मांजरा, तेरणा, मन्याड आणि लेंडी खोऱ्यासाठी कसलही तरतूद नाही. ",
    w_c_slider_text3:
      "त्यामुळे या १६७ टीएमसी पाण्यामधून लातूरच्या न्याय्य हिस्स्याच्या पाण्याचा वाटा मूळस्तोताच ठरवून ते भंडारदरा मार्गे लातूरला आणावे.  ",
    w_c_slider2_title: "धरणांमध्ये साचलेला गाळ काढून ",
    w_c_slider2_span: " पाणी साठा वाढवणे!",
    w_c_slider_text4:
      "वर्षानुवर्ष पाण्यासह वाहून आलेल्या गाळाने धरणांची साठवण क्षमता कमी झाली आहे. त्यामुळे या गाळा इतके लातूरकरांच्या हक्काचे पाणी दरवर्षी वाहून जात आहे.",
    w_c_slider_text5:
      "यासाठी धरणांमध्ये साठलेला गाळ काढून धरणांची खोली वाढवावी, जेणेकरून पाऊसाचे अतिरिक्त पाणी धरणांमध्ये जमा होईल.",
    w_c_slider3_title: "जिल्ह्यातील",
    w_c_slider3_span: " पाझर तलावांची दुरुस्ती!",
    w_c_slider_text6:
      "जिल्ह्यामध्ये शेतकऱ्यांना १२ महिने पाणी मिळावे, यासाठी २००० पाझर तलावांची निर्मिती करण्यात आली आहे. परंतु भूगर्भीय रचना व दुरुस्ती अभावी दरवर्षी यातून १९८ टीएमसी पाणी वाहून अथवा वाफ बनून उडून जाते.",
    w_c_slider_text7:
      "हे रोखण्यासाठी सर्व पाझर तलावांचे सर्वेक्षण करून त्यांची दुरुस्ती करावी. जेणेकरून भूजल पुनर्भरणासह शेतकऱ्यांना कायमस्वरूपी वापरासाठी पाणी उपलब्ध होईल.",

    //Janjagar Manch
    j_j_title: "जन जागर संवाद ",
    j_j_subtitle: "मंथन विचारांचे, ",
    j_j_span: " जनतेच्या विकासाचे",
    j_j_desc:
      "स्वातंत्र्य मिळून ७५ वर्षे लोटूनही मराठवाड्याचा परिपूर्ण विकास झाला नाही. आज लातूरसह मराठवाड्यातील कित्येक जिल्ह्यांना पिण्याच्या पाण्यासारखा मुलभूत गोष्टींसाठी झगडावे लागत आहे. जिथे पाण्याची ही तऱ्हा तर मग उद्योग, रोजगार, पायाभूत सुविधा यांची काय कथा. जिल्ह्यात विकासपूरक वातावरण आणि रोजगार संधी उपलब्ध नसल्यामुळे मोठ्या प्रमाणावर तरुणांचे व नागरिकांचे विस्थापन होऊ लागले. हे सर्व रोखून लातूर जिल्ह्याच्या सर्वांगीण विकासासाठी मा. संभाजी पाटील निलंगेकर यांच्या पुढाकारातून व मार्गदर्शनाखाली ‘जन जागर मंच’ या विकासपीठाची स्थापना करण्यात आली आहे. या मंचाने इस्राईल मॉडेलचा अभ्यास करून ९ क्षेत्रांवर कार्य करण्याचा निर्णय घेतला. या ९ क्षेत्रांशी संबंधित प्रत्येक ५० अशा एकूण ४५० तज्ञ व अभ्यासक व्यक्तींना एकाच मंचावर आणून त्यांच्यात धोरणात्मक चर्चा घडावी व यातून जिल्ह्याच्या विकासासाठी श्वेतपत्रिका तयार करण्याच्या उद्देशाने दि. १२ ऑगस्ट २०२३ रोजी, ‘जन जागर संवाद’ या एक दिवस संवाद कार्यक्रमाचे दयानंद सभागृह, लातूर येथे आयोजन करण्यात आले. ९ विषयांचे ९ स्वतंत्र सत्रे यावेळी घेण्यात आली. तसेच त्या त्या क्षेत्रासंबंधी ९ स्वतंत्र श्वेतपत्रिका तयार करण्यात आल्या व त्यांचे सर्वांसमोर वाचन करण्यात आले. ",

    j_j_text1: "कृषी",
    j_j_desc1: "संयोजक : मा. संभाजी पाटील निलंगेकर",
    j_j_text2: "शिक्षण",
    j_j_desc2: "संयोजक :  मा. अजित पाटील कव्हेकर ",
    j_j_text3: "आरोग्य",
    j_j_desc3: "संयोजक : मा.डॉ. लालासाहेब देशमुख ",
    j_j_text4: "जल संधारण",
    j_j_desc4: "संयोजक : मा. रवींद्र पाठक ",
    j_j_text5: "उद्योग आणि रोजगार",
    j_j_desc5: "संयोजक : मा. उदय पाटील",
    j_j_text6: "महिला व बाल कल्याण",
    j_j_desc6: "संयोजक : मा. प्रेरणा होनराव",
    j_j_text7: "पर्यावरण",
    j_j_desc7: "संयोजक : मा. रामलिंग शेरे",
    j_j_text8: "समाज कल्याण आणि सुरक्षा",
    j_j_desc8: "संयोजक : मा. डॉ. संतोष वाघमारे",
    j_j_text9: "कला, क्रीडा आणि सांस्कृतिक",
    j_j_desc9: "संयोजक : मा. अॅड. शैलेश गोजमगुंडे",
    j_j_maintitle: "चर्चेसाठी निवडण्यात आलेली ",
    j_j_span: " ९ क्षेत्रे",

    /// Drishti
    DAM_pt_title: "दृष्टी अभियान",
    DAM_drushti_abhiyan1: "दृष्टी अभियान १",
    DAM_drushti_abhiyan2: "दृष्टी अभियान २",
    DAM_drushti_abhiyan3: "दृष्टी अभियान ३",
    DAM_drushti_abhiyan4: "दृष्टी अभियान ४",

    //drushti abhiyan 1.0

    DA_pt_title: "दृष्टी अभियान",

    DA_title: "दृष्टी अभियान ",
    DA_description:
      "भारतामध्ये विशेषत: ग्रामीण भागामध्ये डोळ्यांच्या आरोग्याकडे मोठ्या प्रमाणावर दुर्लक्ष केले जाते. आधुनिक सुविधांचा अभाव, आरोग्याविषयी जागृती नसणे यामुळे ग्रामीण भागामध्ये डोळ्यांचे आजार व त्यातही मोतीबिंदू हा विकार फार मोठ्या प्रमाणावर आहे. ग्रामीण भागातील नेत्रविषयक समस्या दूर करण्यासाठी विशेषतः मोतीबिंदूवर एक शाश्वत उपाय म्हणून मा. अरविंद पाटील निलंगेकर यांच्या प्रेरणेतून ‘दृष्टी अभियान’ या महत्त्वाकांक्षी सेवकार्याची सुरुवात करण्यात आली आहे. दि. २० जून ते १७ सप्टेंबर २०२२ दरम्यान या अभियानाचा पहिला टप्पा राबविण्यात आला. लातूरच्या इतिहासामध्ये एका सामाजिक संस्थेच्या मार्फत पहिल्यांदाच नेत्रआरोग्याचा इतका मोठा व अल्पावधीतच प्रचंड लोकप्रिय झालेला कार्यक्रम राबविला गेला आहे.",

    DA_counter_title: " आतापर्यंतची ",
    DA_counter_span: " आकडेवारी ",
    DA_village: "गावांमध्ये शिबिरांचे आयोजन",
    DA_eye_check: "नागरिकांची नेत्रतपासणी",
    DA_spectacles: "मोफत चष्मेवाटप",
    DA_cataract: "नागरिकांवर मोफत मोतीबिंदू शस्त्रक्रिया",

    DA_featured_title: "निवडक ",
    DA_featured_span: " क्षणचित्रे ",

    //drushti abhiyan 2.0
    DA2_pt_title: "दृष्टी अभियान  २.०",
    DA2_title: "दृष्टी अभियान  २.० -",
    DA2_description:
      "नागरिकांचा उदंड प्रतिसाद व अभियानाच्या लोकप्रियतेमुळे खास गरजू नागरिकांच्या आग्रहाखातर संस्थेमार्फत दृष्टी अभियानाचा दुसरा टप्पा यशस्वीपणे राबविण्यात आला. देशाचे आदरणीय पंतप्रधान श्री. नरेंद्र मोदी यांच्या जन्मदिनापासून (१७ सप्टेंबर) देशाचे माजी पंतप्रधान भारतरत्न स्व. अटलबिहारी वाजपेयी यांची जयंती (२५ डिसेंबर) या कालावधीमध्ये हे अभियान पार पडले.",

    //drushti 3.0
    DA3_pt_title: "दृष्टी अभियान ३.०",
    DA3_title: "दृष्टी अभियान ३.० ",
    DA3_description:
      "दृष्टी अभियानाच्या पहिल्या व दुसऱ्या टप्प्याच्या यशस्वी आयोजनानंतर नागरिकांच्या आग्रहामुळे ‘दृष्टी अभियान ३.०’ च्या तिसऱ्या टप्प्याचे आयोजन स्वामी विवेकानंद यांच्या जयंती दिनी (१२ जानेवारी २०२३) करण्यात आले. या टप्प्याची सांगता संस्थेच्या प्रेरणास्थान आदरणीय अक्कांच्या जन्मदिनी अर्थात ४ जून २०२३ रोजी करण्यात आली.",

    //drushti 4.0
    DA4_pt_title: "दृष्टी अभियान ४.०",
    DA4_title: "दृष्टी अभियान ४.०",
    DA4_description:
      "जनतेच्या आग्रहाखातर दृष्टी अभियानाचा चौथा टप्पा देखील सुरु करण्यात आला आहे. अभियानाचा हा टप्पा २० जून ते २५ नोव्हेंबर २०२३ दरम्यान राबवला जाणार आहे. गरजू नागरिकांनी आपल्या गावात होणाऱ्या या शिबिरांचा आवश्य लाभ घ्यावा.",

    // =================================

    // beforefooter

    bf_tilte: "तुम्हीही",
    bf_title_span: "  सहभागी व्हा",
    bf_donate: "मदतीसाठी",
    bf_contact: "संपर्क करा",
    bf_volunteer: "स्वयंसेवक",

    // footer-------------------------------------------
    f_col1_title: "आमचं काम",
    f_col1_li2: "सशक्तीकरण",
    f_col1_li3: "शिक्षण",
    f_col1_li4: "पर्यावरण",
    f_col1_li5: "आरोग्य",
    f_col1_li6: "कला आणि सांस्कृतिक",
    f_col1_li7: "प्रोजेक्ट आनंदी",
    f_col1_li8: "दृष्टी अभियान",

    f_col2_title: "क्रियाशीलता",
    f_col2_li2: "दान",
    f_col2_li3: "स्वयंसेवक",
    f_col2_li4: "ब्लॉग्ज",
    f_col2_li5: "गॅलरी",
    f_col2_li6: "आमच्याबद्दल",
    f_col2_li7: "संपर्क साधा",

    f_col3_title: "कायदेशीर",
    f_col3_li2: "गोपनीयता धोरण",
    f_col3_li3: "कुकीज धोरण",

    //  volunteer---------------page

    vp_pt_title: "स्वयंसेवक",
    vp_title: "चला, स्वयंसेवक बनून इतरांच्या",
    vp_title_span: "जीवनात आनंद पेरूया!",
    vp_title_desc:
      "स्वयंसेवक हा सामाजिक कार्यांचा मोठा आधार असतो. आपले ज्ञान, अनुभव, कौशल्य, वेळ अथवा निधीच्या माध्यमातून ते समाजासाठी योगदान देतात. त्यांच्या याच योगदानातून समाजामध्ये अनेक मोठे सकारात्मक बदल घडत असतात. अक्का फाऊंडेशन देखील आपल्याला या सकारात्मक बदलांमध्ये सहभागी होण्याचे आवाहन करत आहे. आपल्या सहकार्यातून एक आनंदी, सुदृढ आणि भविष्यवेधी समाज घडविण्यासाठी आम्ही सदैव तयार आहोत. गरज आहे ती फक्त आपल्या एक पावलाची...त्यामुळे पुढे येऊन अक्का फाऊंडेशनच्या सेवाकार्यांमध्ये स्वयंसेवक म्हणून सहभागी व्हा...आणि उद्याच्या उज्ज्वल भारतासाठी आपापल्या परीने योगदान द्या!",

    // about------page--------------

    AP_pt_title:
      "अक्का फाऊंडेशन: सर्वांसाठी, सर्वांच्या सर्वांगीण विकासासाठी  ",

    AP_hc_title: "आपल्या सहकार्यातून आपल्या  ",
    AP_hc_span: "सहकार्यासाठी आम्ही सदैव तत्पर आहोत!",
    AP_hc_desc:
      "समाजामध्ये आज अनेक ठिकाणी नागरिकांना आपल्या मुलभूत गरजा भागाविण्यासाठी देखील संघर्ष करावा लागत आहे. विशेषतः ग्रामीण भागामध्ये आज नागरिकांना अनेक अडचणींना तोंड द्यावे लागत आहे. मराठवाडा आणि लातूर सारख्या भागामध्ये या अडचणी अधिक भीषण रूप घेतात. अशावेळी आपल्या देशबांधवांच्या सुखी व निरामयी जीवनासाठी अक्का फाऊंडेशन पुढाकार घेत आहे. महिला सक्षमीकरण, शिक्षण, आरोग्य, पर्यावरण, जलसंवर्धन, शेतकरी कुटुंबांना सहकार्य, कला संस्कृतीचे जतन इ. विविध क्षेत्रांसाठी संस्थेमार्फत कार्य केले जात आहे, दृष्टी, आनंदी या उपक्रमांमधून अनेकांच्या जीवनात सकारात्मक बदल होत आहे. समाज यासर्व गोष्टी पाहत आणि संस्थेच्या कार्यावर विश्वास ठेवून या कार्यात मोठ्या संख्येने सहभागी होत आहे.",

    AP_oh_title: "वारसा समाज",
    AP_oh_span: "परिवर्तनाचा",
    AP_oh_desc:
      "सामाजिक कार्यातून समाज परिवर्तनाच्या दिशेने जाण्याचा हा प्रवास सुरु केला, तो लातूरच्या माजी लोकसभा सदस्य व आमच्या प्रेरणास्थान आदरणीय रूपाताई पाटील निलंगेकर अर्थात अक्कांनी. माहेरी चालुक्य घराण्याचा समृद्ध वारसा आणि सासरी निलंगेकर घराण्याचा सेवेचा संस्कार या दोन्हींचा मिलाप आ. अक्कांच्या ठायी झाला. आपल्या आजपर्यंतच्या जीवनप्रवासात आदरणीय अक्कांनी अनेक लहान मोठी सेवाकार्य राबवली. जनसेवा ही आपलेपणाच्या भावनेतून करा, असा संदेश त्यांनी अनेकांना दिला. विचारातूनच २०१७ मध्ये अक्का फाऊंडेशनची स्थापना झाली.  ",

    AP_ov_title: "वंचितांना स्वयंपूर्ण बनवणे हेच ",
    AP_ov_span: "आमचे ध्येय! ",
    AP_ov_desc:
      "वंचितांना सक्षम करून त्यांना समाजाच्या मुख्य प्रवाहात आणणे हे आमचे मुख्य ध्येय आहे. दुर्बल आणि गुणवान व्यक्तींना विविध संधी आणि कौशल्य विकासाच्या माध्यमातून त्यांना स्वयंपूर्णतेकडे नेऊन मूलभूत सुविधांपासून देखील वंचित असलेल्या लाखो नागरिकांना उत्तम दर्जाचे व आनंदी जीवन देण्यासाठी आम्ही कटिबद्ध आहोत. आनंदी समाजाच्या निर्मितीसाठी आमचे प्रयत्न निरंतर सुरु राहतील. ",

    AP_om_desc_title: "शाश्वत आणि ",
    AP_om_desc_title_span: "परिपूर्णता",
    AP_om_desc_li1:
      "सर्वसमावेशक आणि सर्वांगीण विकासाची व्याख्या समजून समाजातील प्रत्येक वंचित, दु:खी आणि गोरगरीब जनतेचा आवाज ऐकून त्यांच्या विकासासाठी प्रयत्न करणे.   ",
    AP_om_desc_li2:
      "समाजातील नागरिकांना एकत्र घेऊन त्यांच्यातील नेतृत्व गुणांचा विकास करणे. समाजाशी असलेल्या बांधिलकीचा संस्कार रुजवून वैयक्तिक विकासाबरोबरच समाज कार्यामध्ये सहभागी करून घेणे.",
    AP_om_desc_li3:
      "शाश्वत आणि सर्वांगीण विकासाला केंद्र मानून नैतिकता आणि मानवी मुल्यांवर आधारित कार्य करणे. सर्वसमावेशक समाजाच्या दृष्टीने सर्व गरजू नागरिकांना मदतीचा हात देणे.",
    AP_om_desc_li4:
      "सामूहिक कल्याणासाठी आरोग्याच्या दृष्टीने मार्गदर्शक तत्त्वांचे पालन करणे. निरोगी आणि सुरक्षित जीवनासाठी शाश्वत उपाय शोधून त्यावर कार्य करणे. ",
    AP_om_desc_li5:
      " संस्कृती आणि आधुनिकतेची सांगड घालणे. ‘विविधतेतील एकता’ या संकल्पनेला धरून समाजाला एकत्र येण्यासाठी सकारात्मक वातावरण बनवून सर्वांचा शाश्वत विकास साधणे. ",
    AP_om_desc_li6:
      "शेती विकासामध्ये आधुनिक तंत्रज्ञान, वैज्ञानिक दृष्टीकोन आणि सहकार्यात्मक कार्यातून प्रयोग करणे.",
    AP_om_desc_li7:
      "ग्रामीण भागातील महिलांना जागतिक व्यवसायासाठी सक्षम बनविण्यासाठी शाश्वत पद्धतीने त्यांना कौशल्यसंपन्न बनवून आर्थिक व सामाजिक स्तरावर अधिक स्वतंत्र आणि स्वयंपूर्ण बनविणे.",
    AP_om_desc_li8:
      "सामाजिक समस्या उदा. नागरी, आर्थिक व पर्यावरणाशी संबंधित आव्हानांचे विश्लेषण करून त्यावर शाश्वत उपाय शोधणे.",
    AP_om_desc_li9:
      "सर्वांगीण विकासाची व्याप्त वाढविण्यासाठी नवीन तंत्रज्ञानाचा वापर करणे, सर्वसमावेशक आणि शाश्वत उन्नतीसाठी नवनवीन व अभिनव कल्पना सादर केल्या जातात.",

    AP_oi_title: "सदा मग्न ते,",
    AP_oi_span: "नित्य समाजहित कारणी",
    AP_oi_desc:
      "अक्का’ म्हणजे मोठी बहिण आणि मोठी बहिण म्हणजेच दुसरी आई. मोठी बहिण ही कायमच आपल्या सर्व भावंडांचा सांभाळ आईच्या मायेने करत असते. आईपणाचा विचार म्हणजेच वात्सल्य आणि मातृत्वाचा संस्कार. संस्थेच्या प्रेरणास्थान आ. अक्कांच्या प्रत्येक कृतीमध्ये हे वात्सल्य आणि प्रेम निरंतर दिसत असते. त्यामुळे निलंगा आणि आसपासच्या जनतेला त्या नेहमीच आपल्या जवळच्या आणि हक्काच्या वाटतात. आ. अक्कांनी आजपर्यंत अनेक लहान मोठी सेवाकार्य राबवली आहेत. तसेच निस्वार्थ सेवेचा संस्कार त्यांनी आपल्या आसपासच्या सर्व व्यक्तींवर केला. दुःखिताना आपले मानले की त्यांची सर्व दु:खे आपणहून आपली होतात आणि आपली दु:खे दूर करण्यासाठीच आपण तन-मन-धन अर्पून सर्वभावे प्रयत्न करतो. त्यामुळे हा आपलेपणा आपल्या सर्वांमध्ये आला पाहिजे, हाच त्यांच्या कार्याचा मूळ विचार. साधी राहणी आणि उच्च विचार सरणी हे सूत्र घेऊन संस्था निरंतर आ. अक्कांच्या मार्गदर्शनामध्ये कार्य करत असून आज अनेक ठिकाणी संस्थेच्या कार्याचा विस्तार झाला आहे.",

    AP_founder: "",
    AP_founder_span: "संस्थापक",
    AP_of_box1_title: "संभाजी पाटील निलंगेकर",
    AP_of_box1_desc:
      "महाराष्ट्र राज्याचे माजी मंत्री व निलंगा विधानसभा मतदारसंघाचे आमदार श्री. संभाजी पाटील निलंगेकर अक्का फाऊंडेशनचे प्रमुख मार्गदर्शक आहेत. संतश्रेष्ठ ज्ञानेश्वर माऊलींच्या विश्वबंधुत्वाच्या प्रेरणेतून शाश्वत समाजकार्य करण्याचा संस्कार ते संस्थेच्या सर्व स्वयंसेवकांवर नियमित करत असतात. दृष्टी अभियान, प्रोजेक्ट आनंदी, महाआरोग्य अभियान यांसारख्या अनेक उपक्रमांच्या माध्यमातून त्यांनी समाजाप्रती असलेली आपली बांधिलकी जपली आहे. या उपक्रमांमधून आजपर्यंत हजारो लोकांच्या जीवनामध्ये सकारात्मक बदल घडून आला आहे.",

    AP_of_box2_title: "अरविंद पाटील निलंगेकर",
    AP_of_box2_desc:
      "संस्थेचे संस्थापक श्री. अरविंद पाटील निलंगेकर यांनी आदरणीय अक्कांच्या जनकार्याला मूर्त आणि शाश्वत स्वरूप देण्यासाठी अक्का फाऊंडेशनची स्थापना केली. त्यांनी युनिव्हर्सिटी ऑफ सिडनी, ऑस्ट्रेलिया येथून आपले पीजी डिप्लोमा इन अर्बन अँड रिजनल प्लॅनिंगचे शिक्षण पूर्ण केले आहे. २०१६ मध्ये लातूरमध्ये पडलेल्या भीषण दुष्काळा दरम्यान आ. अक्कांनी अनेक लहान मोठी सेवाकार्य सुरु केली. ही सेवाकार्य पुढे कायम सुरु रहावीत, यासाठी त्यांनी संस्थेची स्थापना केली. आज संस्थेमार्फत अनेक अभिनव उपक्रम त्यांच्या मार्गदर्शनाखाली राबवले जात आहेत.",

    AP_of_box3_title: "प्राजक्ता आशिष मारवाह ",
    AP_of_box3_desc:
      "सध्या पुणे येथे वास्तव्य. यशस्वी उद्योजक, सोशल मिडिया अभ्यासक आणि सामाजिक कार्यांमध्ये कायम पुढे असलेल्या प्राजक्ता मारवाह या संस्थेच्या विविध उपक्रमांची धुरा यशस्वीपणे सांभाळत आहेत. वैयक्तिक विकासाबरोबरच समाजातील वंचित घटकांच्या विकासासाठी सर्वांनी पुढे आले पाहिजे, या सकारात्मक विचारातून त्या नेहमी कार्य करतात. दुःखितांचे दु:ख समजून घेऊन त्यावर आईच्या मायेने फुंकर घातल्यास आपल्यालाही जीवनात खरा आनंद मिळू शकतो, या त्यांच्या प्रेरणेतूनच आज संस्थेमध्ये अनेक संवेदनशील उपक्रम आकार घेत आहेत.   ",

    AP_slider_title: "आमचे ",
    AP_slider_title_span: "यश",

    AP_btn_box: "अधिक माहितीसाठी",

    // pagetop___________gallery
    PT_gallery: "गॅलरी",
    Founders: "संस्थापक",

    //project anandi
    PA_main_title: "प्रोजेक्ट आनंदी ",
    Pa_spans: " आपली जबाबदारी...  ",
    Pa_titles: "तिचा गौरव,",
    PA_sdisc:
      "ग्रामीण भागातील महिला आणि मुलींच्या मासिक पाळीच्या आरोग्यविषयक समस्यांवर शाश्वत उपाय म्हणून ‘प्रोजेक्ट आनंदी’ हा अभिनव उपक्रम सुरू करण्यात आला. मासिक पाळीबाबत समाजातील गैरसमज दूर करण्यासाठी या उपक्रमाच्या माध्यमातून मुलींना मोफत सॅनिटरी पॅड उपलब्ध करून दिले. तसेच ग्रामीण महिलांना स्वयंरोजगार उपलब्ध करून देणे हे उद्दिष्ट आहे.",
    counter_title: "आतापर्यंतची ",
    counter_span: "आकडेवारी ",
    counter_stat_1: "शाळा ",
    counter_stat_2: "विद्यार्थिनी ",
    counter_stat_3: "दिवस ",
    counter_stat_4: "कार्यशाळा ",
    //donate page
    DP_food_title: "प्रोजेक्ट आनंदी",
    DP_food_patient: "दृष्टी अभियान",
    DP_food_equipment: "स्त्री सशक्तिकरण",
    DP_food_education: "शिक्षण",
    DP_food_health: "आरोग्य",

    donate_pt_title: "येथे दान करा",

    //education page

    // EP --- Education page
    // pt --- page top
    // hc --- hero card

    EP_pt_text: "शिक्षण",
    EP_hc_title: "विद्यादान,",
    EP_hc_span: "सर्वश्रेष्ठ दान ",
    EP_hc_desc:
      "आजचे विद्यार्थी हे उद्याचे नागरिक आहेत. त्यामुळे देशाच्या या भावी नागरिकांचा शैक्षणिक विकास होऊन त्यांना योग्य मार्गदर्शन मिळणे हे अत्यंत गरजेचे आहे. शिक्षणातूनच व्यक्तीची आणि समाजाची जडणघडण होत असते. देशातील गरिबी आणि गुन्हेगारीचा थेट संबंध हा देशातील साक्षरतेशी असतो. त्यामुळे समाजातील प्रत्येक घटकाला चांगले व दर्जेदार शिक्षण मिळाले पाहिजे. परंतु ग्रामीण भागामध्ये आजही बेताच्या आर्थिक परिस्थितीमुळे अनेक विद्यार्थ्यांना शिक्षणापासून वंचित राहावे लागते. तसेच मार्गदर्शनाचा अभाव व अपुऱ्या साधनांमुळे अनेक सुशिक्षित तरुण चांगल्या संधींपासून दूर आहेत. ज्याचा थेट परिणाम हा त्यांच्या व भविष्यात त्यांच्या कौटुंबिक स्थितीवर होणार आहे. हे सर्व टाळून सर्व विद्यार्थ्यांना दर्जेदार शिक्षण तसेच विकासाच्या संधी उपलब्ध करून त्यांच्या माध्यमातून एक चांगला समाज घडविण्याचा संकल्प अक्का फाऊंडेशनने घेतला आहे. समाजातील कोणताही विद्यार्थी हा शिक्षणापासून वंचित राहू नये. विशेषतः ग्रामीण भागातील मुलींच्या शिक्षणामध्ये येणारे अडथळे दूर करून स्त्री शिक्षणाचा दर उंचावणे, बालमजुरीवर प्रहर करत. आपल्या देशातील बालकांना चांगले भविष्य देण्यासाठी विद्यार्थ्यांच्या मार्गातील अडचणी दूर करून त्यांच्या विकासाचा मार्ग प्रशस्त करण्यासाठी अक्का फाऊंडेशन अनेक शैक्षणिक उपक्रम राबवत आहे. या उपक्रमांना सामाजिक स्तरातून देखील मोठा पाठिंबा मिळत असून यामूळे अनेक विद्यार्थ्यांच्या जीवनात सकारात्मक बदल घडून येत आहेत.",

    EP_is_card1_title: "शैक्षणिक साहित्यांचे वाटप:",
    EP_is_card1_span: "",
    EP_is_card1_desc:
      "शिक्षणाच्या एक समान संधी मिळणे, हा प्रत्येक विद्यार्थ्याचा अधिकार आहे. केवळ साधनांच्या अभावी अथवा गरिबीमुळे कोणताही विद्यार्थी हा शिक्षणापासून वंचित राहू नये, या उद्देशाने ग्रामीण भागातील गरजू व होतकरू विद्यार्थ्यांना संस्थेमार्फत दरवर्षी मोफत शालेय साहित्यांचे वाटप केले जाते. संस्थेमार्फत आजपर्यंत ४ हजार ६०० विद्यार्थ्यांना शैक्षणिक साहित्यांचे वाटप करण्यात आले आहे.",

    EP_is_card2_title: "डिजिटल क्लासरूम",
    EP_is_card2_span: " ",
    EP_is_card2_desc:
      "ग्रामीण भागातील विद्यार्थ्यांना अत्याधुनिक व दर्जेदार शिक्षण मिळावे, या उद्देशाने संस्थेमार्फत डिजिटल क्लासरूमचा उपक्रम राबवला जात आहे. लातूर जिल्ह्यातील काही निवडक शाळांमध्ये प्रायोगिक तत्वावर हा उपक्रम राबवला गेला असून या उपक्रमाला मोठ्या प्रमाणात यश मिळाले आहे. यामुळे विद्यार्थ्यांना डिजिटल बोर्ड, संगणक आदींच्या माध्यमातून विद्यार्थ्यांना यातून उत्तम व आधुनिक शिक्षण मिळत आहे. ",

    EP_is_card3_title: "करिअर समुपदेशन कार्यशाळा: ",
    EP_is_card3_span: "",
    EP_is_card3_desc:
      "भविष्याच्या दृष्टीने तरुण विद्यार्थ्यांना योग्य करिअरची निवड करता यावी, यासाठी संस्थेकडून विद्यार्थ्यांसाठी करिअर समुपदेशन कार्यशाळा राबविण्यात येतात. तसेच स्पर्धा परिक्षांचा अभ्यास करू इच्छिणाऱ्या विद्यार्थ्यांसाठी अभ्यासिकेची सोय संस्थेमार्फत केली गेली आहे.",

    EP_is_card4_title: "गरजू विद्यार्थ्यांना शिष्यवृत्ती व आर्थिक मदत:",
    EP_is_card4_span: "",
    EP_is_card4_desc:
      "शैक्षणिक साहित्य आणि मार्गदर्शनाबरोबरच गरजू विद्यार्थ्यांना पुढील शिक्षणासाठी संस्थेमार्फत शिष्यवृत्ती तसेच वेळेप्रसंगी आर्थिक साहाय्यही ही दिले जाते. देशाचा भावी नागरिक हा कोणत्याही कारणाने शिक्षणापासून वंचित राहू नये, हा एकच प्रामाणिक हेतू घेऊन हे कार्य सुरु आहे.",

    EP_fi_title: "विद्याविनय",
    EP_fi_span: "न शोभती",

    PNF_pt_title: "अरेरे पृष्ठ सापडले नाही!",
    PNF_cta: "परत घराच्या दिशेने",
  },
];
export default marathi;
